import { BillFormLine } from './formData'

export const getBillLinesMock = (count: number): BillFormLine[] => Array.from({ length: count }, Object)
